// Product Tabs JavaScript
// Extracted from main-product.liquid for better organization

// Product Tabs script loaded

// Initialiser les onglets
function initProductTabs() {
  document.querySelectorAll('.tab-button').forEach(button => {
    button.addEventListener('click', () => {
      // Désactiver tous les onglets
      document.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
      document.querySelectorAll('.tab-panel').forEach(panel => panel.classList.remove('active'));
      
      // Activer l'onglet cliqué
      button.classList.add('active');
      const tabId = button.getAttribute('data-tab');
      const targetPanel = document.getElementById(tabId);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });
  });
}

// Initialiser au chargement du DOM
document.addEventListener('DOMContentLoaded', function() {
  initProductTabs();
});

// Exposer la fonction globalement
window.initProductTabs = initProductTabs;
